<div class="isg-menuh-container">
  <nav class="isg-menuh-nav">
    <ul class="isg-menuh" role="menu" aria-orientation="horizontal">
      <ng-container [ngTemplateOutlet]="templateMenuHorizontal"
                    [ngTemplateOutletContext]="{ items : menuItems, level: 1 }">

      </ng-container>
    </ul>
  </nav>
</div>

<ng-template #templateMenuHorizontal let-items="items" let-level="level">

  <ng-container *ngFor="let item of items">

    <ng-container *ngIf="item.hasChildren">
      <ng-container [ngTemplateOutlet]="showChildren"
                    [ngTemplateOutletContext]="{ item: item, level: level }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!item.hasChildren">
      <ng-container [ngTemplateOutlet]="elseNoChildren"
                    [ngTemplateOutletContext]="{ item: item, level: level }">
      </ng-container>
    </ng-container>

  </ng-container>

</ng-template>

<ng-template #showChildren let-item="item" let-level="level" let-menId="id">
  <li role="menuitem" class="isg-mitem-haschildren"
      attr.level="{{assignLevel(item, level)}}"
      [ngClass]="{'isg-mitem-top': level == 1, 'isg-mitem-expanded': item.expanded, 'isg-mitem-expanded-current' : item.currExpanded , 'selected': item.selected}"
      attr.aria-label="{{item.name}}"
      ngbDropdown display="dynamic" (mouseover)="menuenter($event)" (mouseleave)="menuleave($event)"
      data-target="item.id">
    <div class="isg-mitem-content" ngbDropdownToggle>
      <span [ngClass]="getImageClass(item)"></span>
      <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
      <span class="k-spacer"></span>
      <span class="k-icon"></span>
    </div>
    <ul role="menu" class="dropdown-menu submenu" ngbDropdownMenu aria-labelledby="item.id">
      <ng-container [ngTemplateOutlet]="templateMenuHorizontal"
                    [ngTemplateOutletContext]="{ items : item.children , level: level + 1 }">
      </ng-container>
    </ul>
  </li>
</ng-template>

<ng-template #elseNoChildren let-item="item" let-level="level">
  <li role="menuitem"
      [ngClass]="{'isg-mitem-top': level == 1, 'isg-mitem-bookmark': isBookmark(item), 'selected': item.selected }"
      attr.level="{{assignLevel(item, level)}}"
      attr.aria-label="{{item.name}}">
    <ng-container *ngIf="(!(item.url) || item.url.length < 1) && (isExportButton(item))">
      <ng-container [ngTemplateOutlet]="exportbutton"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(!(item.url) || item.url.length < 1)  && (!isExportButton(item))">
      <ng-container [ngTemplateOutlet]="noRoute"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && isItemRouteInternal(item.url)">
      <ng-container [ngTemplateOutlet]="routeInternal"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && !isItemRouteInternal(item.url)">
      <ng-container [ngTemplateOutlet]="routeExternal"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>
  </li>
</ng-template>

<ng-template #noRoute let-item="item">
  <div class="isg-mitem-content">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </div>
</ng-template>

<ng-template #exportbutton let-item="item">
  <div class="isg-mitem-content export-button" title='{{getLinkTitle(item)}}' (click)="exportClick(item)">
    <i [ngClass]="'fa-solid ' + getExportLogo(item)"></i>
  </div>
</ng-template>

<ng-template #routeInternal let-item="item">
  <a class="isg-mitem-content" routerLink="{{item.url}}">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>

<ng-template #routeExternal let-item="item">
  <a class="isg-mitem-content" href="{{item.url}}" target="{{item.target}}">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>


